import type { InitialParams } from '@/app/components/hotel-detail/InitialParamsProvider';

export const BRANDED_FARES_AVAILABLE = 'BRANDED_FARES_AVAILABLE';
export const BRANDED_FARES_AVAILABLE_VERSION = '1.0';

export type BrandedFaresAvailablePayload = {
  searchId: string;
  productDetailKey: string;
  flightClickId: string;
};

export type BrandedFaresAvailableParams = {
  initialParams: Pick<InitialParams, 'hdpSearchId' | 'productDetailKey'>;
  flightClickId: string;
};

export const createBrandedFaresAvailablePayload = ({
  initialParams,
  flightClickId,
}: BrandedFaresAvailableParams): BrandedFaresAvailablePayload => ({
  searchId: initialParams.hdpSearchId,
  productDetailKey: initialParams.productDetailKey,
  flightClickId,
});
